import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  Row
} from 'reactstrap';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import {
  listsDeleteCrm,
  // listsDownload,
  resetListGetById,
  resetListUpdate
} from '../../../store/slices/tenantSlices/configurationSlice';
import { toast } from 'react-toastify';
import * as Icon from 'react-feather';
import DeleteConfirmationModal from '../../../components/Modals/DeleteConfirmationModal';
import ListResetPreviewModal from './ListResetPreviewModal';

const ListResetModal = ({ isOpen, onCancelClick, resetId }) => {
  const dispatch = useDispatch();
  const [resetDetails, setResetDetails] = useState(null);
  const [listInfo, setListInfo] = useState(null);
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [isDeleteId, setIsDeleteId] = useState(null);
  const [exportDetails, setExportDetails] = useState(null);

  const fetchResetListById = async () => {
    try {
      const response = await dispatch(resetListGetById(resetId)).unwrap();
      if (response) {
        setListInfo(response?.list_info);
        setResetDetails(response?.resetlist || []);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  const onClose = (apiCall = false) => {
    onCancelClick(apiCall);
    setSelectedStatuses([]);
    setListInfo(null);
    setResetDetails(null);
  };

  const onResetClick = async () => {
    try {
      const payload = {
        listId: resetId,
        statuses: selectedStatuses?.join(',')
      };
      const response = await dispatch(resetListUpdate(payload)).unwrap();
      if (response && response?.message) {
        toast.success(response.message);
        onClose(true);
      } else {
        toast.error(response.error);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    if (resetId) {
      fetchResetListById();
    }
  }, [resetId]);

  const onCheckboxChange = (status) => {
    setSelectedStatuses((prevStatuses) => {
      if (prevStatuses.includes(status)) {
        return prevStatuses.filter((item) => item !== status);
      } else {
        return [...prevStatuses, status];
      }
    });
  };

  const onDeleteClick = async (status) => {
    try {
      const payload = {
        status: status,
        listId: listInfo?.list_id
      };
      const response = await dispatch(listsDeleteCrm(payload)).unwrap();
      if (response) {
        toast.success(response.message);
        fetchResetListById();
        setIsDeleteId(null);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  const onDownloadClick = async (status) => {
    try {
      const payload = {
        status: status,
        listId: listInfo?.list_id
      };
      setExportDetails(payload);
      // const response = await dispatch(listsDownload(payload)).unwrap();
      // if (response) {
      //   const fileName = `${status}.xlsx`;
      //   const url = window.URL.createObjectURL(response);
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.download = fileName;
      //   link.click();
      //   window.URL.revokeObjectURL(url);
      // }
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <React.Fragment>
      <Modal isOpen={isOpen} size="xl" centered backdrop>
        <ModalBody>
          <div className="pb-4 pt-2">
            <Row>
              <Col>
                <div className="d-flex justify-content-start align-items-center gap-3">
                  <label className="text-primary fw-bolder">LIST RESET</label>
                </div>
              </Col>
              <Col>
                <div className="d-flex justify-content-start align-items-center gap-3">
                  <label>List ID :</label>
                  <label className="text-primary fw-bold">{listInfo?.list_id}</label>
                </div>
              </Col>
              <Col>
                <div className="d-flex justify-content-start align-items-center gap-3">
                  <label>List Name :</label>
                  <label className="text-primary fw-bold">{listInfo?.list_name}</label>
                </div>
              </Col>
              <Col>
                <div className="d-flex justify-content-start align-items-center gap-3">
                  <label>Process :</label>
                  <label className="text-primary fw-bold">{listInfo?.process_name}</label>
                </div>
              </Col>
            </Row>
            <div className="fs-6 pt-2">
              <table className="report-list-table">
                <thead>
                  <tr>
                    <th style={{ width: '30px' }}></th>
                    <th>Status</th>
                    <th>Pending Leads</th>
                    <th>Dialed Leads</th>
                    <th>Total Leads</th>
                    <th>Action </th>
                  </tr>
                </thead>
                <tbody>
                  {resetDetails?.map((val, index) => {
                    return (
                      <tr
                        key={index}
                        style={{
                          background: val?.status === 'Grand Total' ? '#2cabe333' : 'white'
                        }}>
                        <td>
                          <div className="d-flex justify-content-center align-items-center">
                            {val?.status !== 'Grand Total' ? (
                              <FormGroup check className="m-0">
                                <Label check>
                                  <Input
                                    type="checkbox"
                                    id="check_header"
                                    disabled={val?.status === 'NEW'}
                                    checked={selectedStatuses?.includes(val?.status)}
                                    onChange={() => onCheckboxChange(val?.status)}
                                  />
                                </Label>
                              </FormGroup>
                            ) : (
                              <div className="h-100 w-100">&nbsp;</div>
                            )}
                          </div>
                        </td>
                        <td>{val?.status || '-'}</td>
                        <td>{val?.pending_lead || 0}</td>
                        <td>{val?.dialed_lead || 0}</td>
                        <td>{val?.total || 0}</td>
                        <td>
                          <div className="d-flex justify-content-around align-items-center">
                            <div className="cursor-pointer text-info">
                              <Icon.Download
                                size={16}
                                onClick={() =>
                                  onDownloadClick(
                                    val?.status === 'Grand Total' ? 'All' : val?.status
                                  )
                                }
                              />
                            </div>
                            <div className="cursor-pointer text-danger">
                              <Icon.Trash
                                size={16}
                                onClick={() =>
                                  setIsDeleteId(val?.status === 'Grand Total' ? 'All' : val?.status)
                                }
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <Button className="px-5 bg-danger border-danger" onClick={() => onClose()}>
            Cancel
          </Button>
          <Button
            onClick={() => onResetClick()}
            disabled={selectedStatuses.length === 0}
            className="px-5 bg-primary border-primary">
            Reset
          </Button>
        </ModalFooter>
      </Modal>
      <DeleteConfirmationModal
        isOpen={!!isDeleteId}
        onCloseClick={() => setIsDeleteId(null)}
        onDeleteClick={() => onDeleteClick(isDeleteId)}
      />
      {exportDetails && (
        <ListResetPreviewModal
          isOpen={exportDetails}
          exportDetails={exportDetails}
          onCloseModal={() => setExportDetails(null)}
        />
      )}
    </React.Fragment>
  );
};

ListResetModal.propTypes = {
  isOpen: PropTypes.bool,
  resetId: PropTypes.number,
  onCancelClick: PropTypes.func
};

export default ListResetModal;
